import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StateService} from "../../services/state.service";
import {UserRole, UserStatus} from "../../models/user";
import {Router} from "@angular/router";
import {UtilService} from "../../services/util.service";

@Component({
    selector: 'app-unauthorized-user',
    templateUrl: './unauthorized-user.component.html',
    styleUrls: ['./unauthorized-user.component.scss'],
    standalone: false
})
export class UnauthorizedUserComponent implements OnInit, AfterViewInit {
  public type! : string;

  constructor(private stateService : StateService,
              private router : Router,
              private util: UtilService) { }

  ngOnInit(): void {
    if (this.stateService.isLoggedIn) {
      if (this.stateService.userRole != UserRole.GAO_Admin) {
        this.type = "admin"
      } else {
        // Shouldn't need a default as any redirection here should be covered by other cases
        this.type = "default"
      }

      // if (this.stateService.userStatus === UserStatus.New) {
      //   this.type = "newreg"
      // } else if (this.stateService.userStatus === UserStatus.Deactive) {
      //   this.type = "disabled"
      // } else if (this.stateService.userStatus === UserStatus.Locked) {
      //   this.type = "denied"
      // } else if (this.stateService.userRole != UserRole.GAO_Admin) {
      //   this.type = "admin"
      // }
    } else {
      this.type = "notloggedin"
    }
  }

  ngAfterViewInit(): void {
    // looks strange setting equal to self, but it's a getter and setter
    this.stateService.redirectUrl = this.stateService.redirectUrl;
  }

  goLanding() {
    this.router.navigate(['/']);
  }

  goDashboard() {
    this.router.navigate([this.util.getDashboardURL()]);
  }
}
